import {
  ColumnFiltersState,
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable
} from '@tanstack/react-table';
import { DebugToggle } from '../internal.models';
import { getDebugToggleColumnDefs } from './debug-toggle-column-defs';
import { CustomTable } from 'common/components/table/customTable';
import { useState } from 'react';
import { fuzzyFilter } from 'common/components/table/table-functions/filters';

export interface DebugToggleTableProps {
  debugToggles: DebugToggle[];
}

export const DebugToggleTable = ({ debugToggles }: DebugToggleTableProps) => {
  const columnDefs = getDebugToggleColumnDefs();

  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const internalTable = useReactTable({
    data: debugToggles,
    columns: columnDefs,
    filterFns: {
      fuzzy: fuzzyFilter
    },
    state: {
      columnFilters
    },
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    enableColumnResizing: false,
    debugTable: false,
    debugHeaders: false,
    debugColumns: false
  });

  return (
    <CustomTable
      key={`internal-table`}
      componentId={'internal-table'}
      table={internalTable}
      cellClasses=""
    />
  );
};

export default DebugToggleTable;
